import Navbar from "./Navbar";

function Header() {
    return (
        <div className="App-header">
            <h1>
                {"Wojciech Liss"}
            </h1>
            <Navbar />
        </div>
    )
}

export default Header;